import React from 'react';
import { ReservoirChatContext } from './ReservoirChatContext';

// Holds the current page/report descriptor. Report pages call setChatContext on
// mount/update and clear (null) on unmount, so navigating away drops stale context.
export default function ChatContextProvider({ children }) {
  const [context, setContext] = React.useState(null);
  // Apply-callback registered by the report builder (non-model channel; see ReservoirChatContext).
  const [builderApply, setApply] = React.useState(null);
  // Reload-callback registered by the active report (non-model channel; see ReservoirChatContext).
  const [reloadReport, setReload] = React.useState(null);

  // Stable setter so effects in pages don't re-run every render.
  const setChatContext = React.useCallback((next) => setContext(next ?? null), []);
  // Stable setter; wrap in an updater so a passed function isn't invoked as a state initializer.
  const setBuilderApply = React.useCallback((fn) => setApply(() => (fn ?? null)), []);
  const setReloadReport = React.useCallback((fn) => setReload(() => (fn ?? null)), []);

  const value = React.useMemo(
    () => ({ context, setChatContext, builderApply, setBuilderApply, reloadReport, setReloadReport }),
    [context, setChatContext, builderApply, setBuilderApply, reloadReport, setReloadReport],
  );
  return <ReservoirChatContext.Provider value={value}>{children}</ReservoirChatContext.Provider>;
}
